import { render, staticRenderFns } from "./SkvAcademyMaterial.vue?vue&type=template&id=99056d5a&scoped=true"
import script from "./SkvAcademyMaterial.vue?vue&type=script&lang=js"
export * from "./SkvAcademyMaterial.vue?vue&type=script&lang=js"
import style0 from "./SkvAcademyMaterial.vue?vue&type=style&index=0&id=99056d5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99056d5a",
  null
  
)

export default component.exports